import { React } from "react";
import { SiElixir, SiCplusplus } from "react-icons/si";
import { FaJs, FaJava, FaPython } from "react-icons/fa";

const Skills = () => {
  return (
    <div className="flex flex-col items-stretch justify-start px-11">
      <div>
        <div className="p-4 text-4xl text-light-analogous-1">Languages</div>
        <ul className="flex flex-row justify-start">
          <li className="m-5 h-20 w-20  rounded-lg p-5 text-5xl text-light-analogous-2  shadow-xl">
            <FaJava />
          </li>
          <li className="m-5 h-20 w-20  rounded-lg p-5 text-5xl text-light-analogous-2 shadow-xl">
            <SiCplusplus />
          </li>
          <li className="m-5 h-20 w-20  rounded-lg p-5 text-5xl text-light-analogous-2 shadow-xl">
            <FaJs />
          </li>
          <li className="m-5 h-20 w-20  rounded-lg p-5 text-5xl text-light-analogous-2 shadow-xl">
            <FaPython />
          </li>
          <li className="m-5 h-20 w-20  rounded-lg p-5 text-5xl text-light-analogous-2 shadow-xl">
            <SiElixir />
          </li>
        </ul>
      </div>
      <div className="flex flex-col justify-start">
        <div className="p-4 text-4xl text-light-analogous-1">
          Areas of Expertise
        </div>
        <ul className=" flex w-2/3 flex-col justify-start font-google-roboto dark:text-dark-primary-2">
          <li className="m-5 h-20 rounded-lg p-5 text-xl shadow-xl">
            Designing highly available applications
          </li>
          <li className="m-5 h-20 rounded-lg p-5 text-xl shadow-xl">
            Data Engineering
          </li>
          <li className="m-5 h-20 rounded-lg p-5 text-xl shadow-xl">
            Mobile app development
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Skills;
